import { render, staticRenderFns } from "./CheckboxInput.vue?vue&type=template&id=45865822&scoped=true&"
import script from "./CheckboxInput.vue?vue&type=script&lang=ts&"
export * from "./CheckboxInput.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxInput.vue?vue&type=style&index=0&id=45865822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45865822",
  null
  
)

export default component.exports